// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_ahLVt","placeHolder":"index_placeHolder_phg0S","text":"index_text_TUMHu"};